var lib_core = require("lib-core");
var ComponentAttribute = require('./componentAttribute.js');
var lib_geometry = require("lib-geometry");
var EllipseData = require('../../../svg/ellipseData.js');
var PathData = require('../../../svg/pathData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');
var IPCRules = require('../ipcRules');
var DfnPackageWithIdenticalPadsData = require('./dfnPackageWithIdenticalPadsData.js');

var Dfn2Data = function(position, angle, init) {
    DfnPackageWithIdenticalPadsData.apply(this, arguments);
};

lib_core.inherit(Dfn2Data, DfnPackageWithIdenticalPadsData);
lib_core.JsonParser.registerClass(Dfn2Data, "Dfn2Data");

module.exports = Dfn2Data;

Dfn2Data.prototype.getSilkscreen = function(pads) {
	var self = this;
    var silkscreen = [];

    //no silkscreen if there are no pads
    if(pads.length === 0) return silkscreen;

    //TODO-CHECK: if number of pads in left side is less than 1 dont draw silkscreen
    if (self.component.padsPerSide[0] < 1) return silkscreen;

    //get body dimesnsions depending on mapping type of silkscreen to body
    var body = self.getBodyForSilkscreen();
    var leftPad = pads[0];

    //////////////////////////////
    //   Component Silkscreen   //
    //////////////////////////////

    var topLineY;
    var bottomLineY;
    var pathData;

    if(leftPad.getPos().y + leftPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance + IPCRules.silkscreenStrokeWidth / 2 > body.height / 2) {
        topLineY = leftPad.getPos().y + leftPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance + IPCRules.silkscreenStrokeWidth / 2;
        bottomLineY = leftPad.getPos().y - leftPad.getTopCopper().height() / 2 - IPCRules.silkscreenClearance - IPCRules.silkscreenStrokeWidth / 2;
    } else {
        topLineY = body.height / 2;
        bottomLineY = - body.height / 2;
    }

    if(self.componentFamily() !== ComponentAttribute.dfnComponentFamily.DFN_2["DIODE"]) {
    	/////////////////////////////////////////////////////////
        //   Component Silkscreen for non-polarized component  //
        /////////////////////////////////////////////////////////

        //top line
        pathData = new PathData(new lib_geometry.Coord(body.width / 2, topLineY), IPCRules.silkscreenStrokeWidth);
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(-body.width / 2, topLineY), PathType.LINE));
        silkscreen.push(pathData);

        //bottom line
        pathData = new PathData(new lib_geometry.Coord(body.width / 2, bottomLineY), IPCRules.silkscreenStrokeWidth);
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(-body.width / 2, bottomLineY), PathType.LINE));
        silkscreen.push(pathData);
    } else {
        /////////////////////////////////////////////////////////
        //   Component Silkscreen for polarized component      //
        /////////////////////////////////////////////////////////

        var lineStartX = leftPad.getPos().x - leftPad.getTopCopper().width() / 2 - IPCRules.silkscreenClearance;

        pathData = new PathData(new lib_geometry.Coord(body.width / 2, topLineY), IPCRules.silkscreenStrokeWidth);
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(lineStartX, topLineY), PathType.LINE));
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(lineStartX, bottomLineY), PathType.LINE));
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, bottomLineY), PathType.LINE));
        silkscreen.push(pathData);
    }

    return silkscreen;
};
